import "./AuthenticationReview.css";
import React from "react";

// Older invitation links remain readable, but no longer start a Myinfo session.
const PropLoanConfirmation = () => (
  <div
    className="auth-flow-page auth-owner-page"
    style={{ display: "grid", placeItems: "center", padding: 24 }}
  >
    <main
      style={{
        maxWidth: 580,
        width: "100%",
        border: "1px solid #e3e6f6",
        borderRadius: 16,
        padding: 28,
        background: "white",
      }}
    >
      <a
        href="/home"
        style={{ color: "#6d5cf6", fontSize: 28, fontWeight: 700 }}
      >
        SmartLend.
      </a>
      <h1 style={{ marginTop: 24, fontSize: 24 }}>
        Co-owner authorisation is no longer required
      </h1>
      <p>
        Property loan applications can now be listed in the SmartLend
        marketplace as soon as the applicant submits them. You do not need to
        authenticate or send any information through this invitation link.
      </p>
      <a href="/home">Return to SmartLend →</a>
    </main>
  </div>
);

export default PropLoanConfirmation;
